<template>
  <el-dialog
    :title="`关联游戏 - ${tagData ? tagData.title : ''} (已关联 ${pagination.total} 个游戏)`"
    :visible="visible"
    width="1200px"
    :close-on-click-modal="false"
    class="page-dialog center-dialog"
    @update:visible="$emit('update:visible', $event)"
    @closed="handleDialogClosed"
  >
    <div class="page-content page-search">
      <div class="search-form-wrap">
        <el-form size="mini" :model="searchForm" label-position="right" class="search-form-flex" @submit.native.prevent>
          <el-row :gutter="12">
            <el-col :span="8">
              <el-form-item label="游戏名称">
                <el-input v-model="searchForm.game_name" placeholder="请输入游戏名称" clearable></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="8">
              <el-form-item label="游戏厂商">
                <el-input v-model="searchForm.game_provider" placeholder="请输入游戏厂商" clearable></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="8" style="text-align: right">
              <el-button type="primary" size="mini" :loading="loading" @click="handleSearch">筛选</el-button>
              <el-button size="mini" :disabled="loading" @click="handleReset">重置</el-button>
            </el-col>
          </el-row>
        </el-form>
      </div>
      <div class="toolbar">
        <span class="tip">已选择 {{ selectedGameIds.length }} 个游戏</span>
        <!-- <el-button type="text" size="mini" :disabled="selectedGameIds.length === 0" @click="clearSelected">清空已选</el-button> -->
      </div>
      <el-table
        ref="gameTable"
        :data="gameList"
        border
        stripe
        fit
        style="width: 100%"
        max-height="400"
        @selection-change="handleSelectionChange"
      >
        <el-table-column type="selection" width="48" align="center"></el-table-column>
        <el-table-column prop="sort" label="排序" width="220" align="center">
          <template slot-scope="scope">
            <div class="sort-cell">
              <template v-if="!isSortEditing(scope.row)">
                <span class="sort-cell__value">{{ scope.row.sort }}</span>
                <el-button
                  type="text"
                  size="mini"
                  :disabled="!getRowGameId(scope.row)"
                  @click="startSortEdit(scope.row)"
                >
                  编辑
                </el-button>
              </template>
              <template v-else>
                <el-input-number
                  v-model="sortDraftValue"
                  :min="1"
                  :step="1"
                  :precision="0"
                  :controls="false"
                  size="mini"
                  placeholder="序号"
                  class="sort-cell__input"
                  @keydown.native.enter.prevent="saveRelatedGameSort(scope.row)"
                />
                <el-button
                  type="text"
                  size="mini"
                  :loading="sortSavingId === getRowGameId(scope.row)"
                  @click="saveRelatedGameSort(scope.row)"
                >
                  保存
                </el-button>
                <el-button type="text" size="mini" :disabled="sortSavingId === getRowGameId(scope.row)" @click="cancelSortEdit">
                  取消
                </el-button>
              </template>
            </div>
          </template>
        </el-table-column>
        <el-table-column prop="game_name" label="游戏名称" min-width="160"></el-table-column>
        <el-table-column prop="game_provider" label="游戏品牌" min-width="100"></el-table-column>
        <el-table-column prop="game_type" label="游戏类型" min-width="100"></el-table-column>
        <!-- <el-table-column prop="vendor_code" label="厂商" min-width="120"></el-table-column> -->
      </el-table>
    </div>

    <!-- 分页组件 -->
    <div class="pagination-container" style="margin-top: 16px; text-align: right">
      <el-pagination
        :current-page="pagination.currentPage"
        :page-size="pagination.pageSize"
        :page-sizes="[10, 20, 50, 100, 200]"
        layout="total, sizes, prev, pager, next, jumper"
        :total="pagination.total"
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
      />
    </div>

    <template slot="footer">
      <el-button size="small" :disabled="loading" @click="handleCancel">取消</el-button>
      <el-button
        type="danger"
        size="small"
        :loading="loading"
        :disabled="selectedGameIds.length === 0"
        @click="handleConfirm"
        >取消关联</el-button
      >
    </template>
  </el-dialog>
</template>

<script>
import { listGameItems, removeGameItemTags, updateGameItem } from '@/api/gameManage/gameList.js'

export default {
  name: 'ManageGameTagRelationDialog',
  props: {
    visible: {
      type: Boolean,
      default: false,
    },
    tagData: {
      type: Object,
      default: null,
    },
  },
  data() {
    return {
      gameList: [],
      sortSavingId: '',
      sortEditingId: '',
      sortDraftValue: null,
      loading: false,
      selectedGameIds: [],
      searchForm: {
        game_name: '',
        game_provider: '',
      },
      pagination: {
        currentPage: 1,
        pageSize: 20,
        total: 0,
      },
    }
  },
  watch: {
    tagData: {
      handler(newVal) {
        if (newVal) {
          this.pagination.currentPage = 1
          this.loadAvailableGames()
        }
      },
      deep: true,
    },
  },
  mounted() {
    if (this.tagData) {
      this.loadAvailableGames()
    }
  },
  methods: {
    handleDialogClosed() {
      this.gameList = []
      this.sortSavingId = ''
      this.sortEditingId = ''
      this.sortDraftValue = null
      this.loading = false
      this.selectedGameIds = []
      this.searchForm = {
        game_name: '',
        game_provider: '',
      }
      this.pagination = {
        currentPage: 1,
        pageSize: 20,
        total: 0,
      }
    },

    handleCancel() {
      this.$emit('update:visible', false)
    },

    getRowGameId(row) {
      return String(row?.game_id || row?.id || '')
    },

    isSortEditing(row) {
      return this.sortEditingId === this.getRowGameId(row)
    },

    startSortEdit(row) {
      const id = this.getRowGameId(row)
      if (!id) return
      this.sortEditingId = id
      this.sortDraftValue = row.sort != null ? Number(row.sort) : 1
    },

    cancelSortEdit() {
      this.sortEditingId = ''
      this.sortDraftValue = null
    },

    handleSelectionChange(selection) {
      this.selectedGameIds = (selection || []).map(row => this.getRowGameId(row)).filter(Boolean)
    },

    clearSelected() {
      this.selectedGameIds = []
      this.$refs.gameTable && this.$refs.gameTable.clearSelection && this.$refs.gameTable.clearSelection()
    },

    async loadAvailableGames() {
      try {
        const params = {
          page: this.pagination.currentPage,
          page_size: this.pagination.pageSize,
          tags: [this.tagData ? this.tagData.title : ''],
          game_name: this.searchForm.game_name,
          game_provider: this.searchForm.game_provider,
        }
        Object.keys(params).forEach(key => {
          if (!params[key] && params[key] !== 0) delete params[key]
        })
        const response = await listGameItems(params)
        if (response.code === 0) {
          this.cancelSortEdit()
          const raw = response.data.list || []
          const base = (this.pagination.currentPage - 1) * this.pagination.pageSize
          this.gameList = raw.map((item, idx) => ({
            ...item,
            sort: item.sort != null ? Number(item.sort) : base + idx + 1,
          }))
          this.pagination.total = response.data.total
          this.$nextTick(() => {
            this.clearSelected()
          })
        } else {
          this.$message.error('加载可关联游戏失败：' + (response.msg || '未知错误'))
        }
      } catch (error) {
        this.$message.error('加载可关联游戏失败：' + error.message)
        console.error('加载可关联游戏失败:', error)
      }
    },

    handleSizeChange(size) {
      this.pagination.pageSize = size
      this.pagination.currentPage = 1
      this.loadAvailableGames()
    },

    handleCurrentChange(current) {
      this.pagination.currentPage = current
      this.loadAvailableGames()
    },

    handleSearch() {
      this.pagination.currentPage = 1
      this.loadAvailableGames()
    },

    handleReset() {
      this.searchForm.game_name = ''
      this.searchForm.game_provider = ''
      this.pagination.currentPage = 1
      this.loadAvailableGames()
    },

    /** 与 ManageGameDialog 编辑提交一致：tags 须为标签名称数组，避免清空其它标签 */
    normalizeTagsForUpdate(row) {
      const tags = row.tags
      if (!tags) return []
      if (Array.isArray(tags)) {
        return tags.map(t => (typeof t === 'object' && t != null && t.title ? t.title : String(t))).filter(Boolean)
      }
      return String(tags)
        .split(/[,，、]/)
        .map(s => s.trim())
        .filter(Boolean)
    },

    async saveRelatedGameSort(row) {
      const gameId = this.getRowGameId(row)
      if (!gameId) {
        this.$message.warning('无法识别游戏 ID')
        return
      }
      if (!this.isSortEditing(row)) {
        this.$message.warning('请先点击编辑')
        return
      }
      if (!this.tagData?.title) {
        this.$message.warning('标签信息缺失')
        return
      }
      const sort = Number(this.sortDraftValue)
      if (!Number.isFinite(sort) || sort < 1) {
        this.$message.warning('排序须为不小于 1 的整数')
        return
      }
      let tagTitles = this.normalizeTagsForUpdate(row)
      if (!tagTitles.length) {
        tagTitles = [String(this.tagData.title)]
      }
      this.sortSavingId = gameId
      try {
        const payload = {
          game_id: gameId,
          sort,
          status: row.status != null ? Number(row.status) : 1,
          tags: tagTitles,
        }
        const response = await updateGameItem(payload)
        if (response.code === 0) {
          this.$message.success('排序已更新')
          this.cancelSortEdit()
          await this.loadAvailableGames()
        } else {
          this.$message.error('更新排序失败：' + (response.msg || '未知错误'))
        }
      } catch (error) {
        this.$message.error('更新排序失败：' + (error.message || '未知错误'))
        console.error('更新标签内游戏排序失败:', error)
      } finally {
        this.sortSavingId = ''
      }
    },

    async handleConfirm() {
      if (!this.tagData?.title) {
        this.$message.warning('标签信息缺失，无法取消关联')
        return
      }
      if (!this.selectedGameIds.length) {
        this.$message.warning('请至少选择一个游戏')
        return
      }
      try {
        this.loading = true
        const payload = {
          game_id: this.selectedGameIds.map(String),
          tags: String(this.tagData.title),
        }
        const response = await removeGameItemTags(payload)
        if (response.code !== 0) {
          this.$message.error('取消关联失败：' + (response.msg || '未知错误'))
          return
        }
        this.$message.success('取消关联成功')
        this.$emit('save-success')
        this.$emit('update:visible', false)
      } catch (error) {
        this.$message.error('取消关联失败：' + error.message)
        console.error('取消关联失败:', error)
      } finally {
        this.loading = false
      }
    },
  },
}
</script>

<style scoped>
.pagination-container {
  margin-top: 16px;
  text-align: right;
}

.search-form-wrap {
  margin-bottom: 8px;
}

.toolbar {
  margin-bottom: 8px;
  display: flex;
  align-items: center;
  justify-content: space-between;
}

.tip {
  color: #606266;
  font-size: 12px;
}

.sort-cell {
  display: flex;
  align-items: center;
  justify-content: center;
  flex-wrap: wrap;
  gap: 6px;
}

.sort-cell__value {
  min-width: 36px;
  text-align: right;
}

.sort-cell__input {
  width: 100px;
}
</style>
